module.exports = __webpack_public_path__ + "img/bybit_logo.86d9fc84.png";